"use strict";Object.defineProperty(exports, "__esModule", {value: true});

var _UGAVMSQJcjs = require('../__chunks/UGAVMSQJ.cjs');
require('../__chunks/GDZQUFNP.cjs');
require('../__chunks/VC22SYOD.cjs');
require('../__chunks/I4CBIWTX.cjs');


var _WMTGHDLEcjs = require('../__chunks/WMTGHDLE.cjs');


var _4TRESXTOcjs = require('../__chunks/4TRESXTO.cjs');

// src/radio/radio-store.ts
function createRadioStore({
  ...props
} = {}) {
  var _a;
  const syncState = (_a = props.store) == null ? void 0 : _a.getState();
  const composite = _UGAVMSQJcjs.createCompositeStore.call(void 0, {
    ...props,
    focusLoop: _4TRESXTOcjs.defaultValue.call(void 0, props.focusLoop, syncState == null ? void 0 : syncState.focusLoop, true)
  });
  const initialState = {
    ...composite.getState(),
    value: _4TRESXTOcjs.defaultValue.call(void 0, 
      props.value,
      syncState == null ? void 0 : syncState.value,
      props.defaultValue,
      null
    )
  };
  const radio = _WMTGHDLEcjs.createStore.call(void 0, initialState, composite, props.store);
  return {
    ...composite,
    ...radio,
    setValue: (value) => radio.setState("value", value)
  };
}


exports.createRadioStore = createRadioStore;
